import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 566 521",
    path: "M0.457031 520.191C139.586 204.273 408.106 379.186 565.457 0.191406",
    dots: [
        { cx: 97.6143, cy: 382.426, r: 12.2432, ry: 12.4303, delay: 0.4 },
        { cx: 256.552, cy: 291.27, r: 12.2432, ry: 12.4303, delay: 0.8 },
    ],
    gradient: { x: 282.957, y1: 0.191406, y2: 520.191 },
};

const Line1 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line1;
